import request from '@/utils/request';

const OAUTH_CLIENT_URL = '/oauth/clients';

export function getOauthClientList(params) {
  return request({
    url: OAUTH_CLIENT_URL,
    method: 'GET',
    params,
  });
}

export function createOauthClient(data) {
  return request({
    url: OAUTH_CLIENT_URL,
    method: 'POST',
    data,
  });
}

export function updateOauthClient(id, data) {
  return request({
    url: `${OAUTH_CLIENT_URL}/${id}`,
    method: 'PUT',
    data,
  });
}

export function deleteOauthClient(id) {
  return request({
    url: `${OAUTH_CLIENT_URL}/${id}`,
    method: 'DELETE',
  });
}

export function revokeOauthClientToken(id) {
  return request({
    url: `${OAUTH_CLIENT_URL}/${id}/revoke`,
    method: 'POST',
  });
}
